import { Component, Input, AfterViewInit } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import { DaoService } from '../../../core/dao/dao.service';
import { IMenuItem } from '../../../core/models/plugin.model';

@Component({
  selector: 'app-admin-user-detail',
  templateUrl: './admin.user.detail.html',
  styleUrls: ['./admin.user.detail.scss']
})
export class AdminUserDetailGridComponent implements AfterViewInit {
  @Input() data!: any;
  dataSource!: DataSource;
  columns: any[] = [];
  constructor(private dao: DaoService) {
    this.initGrid();
  }

  initGrid() {

    this.columns = [
      {
        dataField: "name",
        allowEditing: true
      },
      {
        dataField: "timestamp",
        allowEditing: true
      },
      {
        dataField: "lastUpdate",
        allowEditing: true
      },
      {
        dataField: "progress",
        allowEditing: true
      },
      {
        dataField: "status",
        allowEditing: true
      },
      {
        dataField: "statusMessage",
        allowEditing: true,
        width: 250
      },
      {
        dataField: "downloadUrl",
        allowEditing: true,
        width: 200
      }
    ]
  }

  ngAfterViewInit() {
    const userId = this.data.row.data.id;
    this.dao.GetTasksByUserId(userId)
      .subscribe(result => {
        this.dataSource = new DataSource({
          store: new ArrayStore({
            data: result
          })
        });
      }, error => {

      })
  }

}
